var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("Contact")]),_c('router-link',{attrs:{"to":"/"}},[_vm._v(" Cancel ")]),_c('a',[_vm._v(" Submit ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }